<template>
  <div class="entranceTask">
    <common-title
      titleName="入学任务"
      :isDone="isDone"
    />
    <img
      class="title"
      src="@/assets/img/entranceTask/title.png"
      alt=""
    >
    <ul class="taskList">
      <li v-if="taskInfo.agreementId">
        <img
          src="@/assets/img/entranceTask/icon1.png"
          alt=""
        >
        <p>签署入学协议</p>
        <router-link :to="{path:'/agreementDetail',query:{userProductId: id} }">
          {{taskInfo.agreementDone ? '查看协议' : '去签署'}}
        </router-link>
      </li>
      <li v-if="taskInfo.examinationFlag">
        <img
          src="@/assets/img/entranceTask/icon2.png"
          alt=""
        >
        <p>填写入学信息</p>
        <router-link
          v-if="!taskInfo.examinationDone"
          to="/archives"
        >
          去填写
        </router-link>
        <router-link
          v-else
          to="/ownArchives"
        >
          去修改
        </router-link>
      </li>
      <li v-if="taskInfo.examId">
        <img
          src="@/assets/img/entranceTask/icon3.png"
          alt=""
        >
        <p>进行入学测试</p>
        <a
          v-if="!taskInfo.examDone"
          @click="goMockExam(1)"
        >去测试</a>
        <a
          v-else
          @click="goMockExam(2)"
        >查看成绩</a>
      </li>
      <li v-if="needAddress">
        <img
          src="@/assets/img/entranceTask/icon4.png"
          alt=""
        >
        <p>填写收货地址</p>
        <router-link :to="{path:'/personalCenter/address',query:{sourse:1 } }">去填写</router-link>
      </li>
    </ul>
    <!-- 一键加群 -->
    <div
      class="aKeyGroup"
      @click="GroupBtn"
      v-if="isContainCommunity===1"
    >
      <img
        src="@/assets/img/entranceTask/group.png"
        alt=""
      >
    </div>
    <div
      :class="['fixBottom',{isDone: !isDone}]"
      @click="goback"
    >
      开始学习
    </div>
    <!-- 加群-->
    <van-popup
      v-model="showPop"
      position="bottom"
      :get-container="getContainer"
    >
      <div
        class="close-btn"
        @click="showPop = false"
      >
        <van-icon name="cross" />
      </div>
      <component
        v-if="showPop"
        :is="communityType | typeToComponentName"
        :communityInfo="communityInfo"
      />
    </van-popup>

    <Loading ref="loading" />
  </div>
</template>
<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import Loading from '@/components/loading/loading.vue';
import { getTaskApi } from '@/api/entranceTask';
import { getNoBindAddressNum } from '@/api/personal/logistics/index';
import { reqCourseDetail } from '@/api/learningGuidePage';
import { reqCourseCommunitySku } from '@/api/courseDetail/community/community';
import qqPopupComponent from '@/components/courseDetail/footCommuntiy/qqPopupComponent.vue';
import wxPopupComponent from '@/components/courseDetail/footCommuntiy/wxPopupComponent.vue';

export default {
  filters: {
    /** 根据type找到组件 */
    typeToComponentName(val) {
      let componentName;
      if (val === '1-1' || val === '1-2') {
        componentName = 'qqPopupComponent';
      } else if (val === '2-1' || val === '2-2' || val === 'wxAccount') {
        componentName = 'wxPopupComponent';
      }
      return componentName || '';
    },
  },
  data() {
    return {
      id: this.$route.query.id, // 开课记录ID
      taskInfo: {},
      needAddress: false,
      isContainCommunity: null,
      showPop: false,
      listInfo: [],
      communityList: {
        '1-1': {
          imgUrl: 'icon_qq.png',
          title: '一键加群',
          platform: 1, // 社交平台 1qq 2微信
          integer: 1, // 账号类型 1群号 2个人号
        },
        '1-2': {
          imgUrl: 'icon_qq.png',
          title: '添加助教',
          platform: 1,
          integer: 2,
        },
        '2-1': {
          imgUrl: 'icon_wechat.png',
          title: '加入微信群',
          platform: 2,
          integer: 1,
        },
        '2-2': {
          imgUrl: 'icon_teacher_wx.png',
          title: '添加老师微信',
          platform: 2,
          integer: 2,
        },
        wxAccount: {
          imgUrl: 'icon_wx_account.png',
          title: '关注公众号',
          platform: 1,
          integer: 1,
        },
      },
      communityType: '', // 社群按钮类型
      communityInfo: {}, // 社群详情信息
    };
  },
  computed: {
    isDone() {
      const {
        agreementId, agreementDone, examId, examDone, examinationFlag, examinationDone,
      } = this.taskInfo;
      if ((agreementId && !agreementDone) || (examId && !examDone) || (examinationFlag && !examinationDone)) {
        return false;
      }
      return true;
    },
  },
  components: {
    CommonTitle,
    Loading,
    qqPopupComponent,
    wxPopupComponent,

  },
  methods: {
    getContainer() {
      return document.querySelector('.entranceTask');
    },

    goback() {
      if (this.isDone) {
        this.$router.go(-1);
      }
    },
    async getAddress() { // 是否有未发货的书
      const { code, data } = await getNoBindAddressNum();
      this.$refs.loading.show = false;
      if (code === 0) {
        this.needAddress = !!data;
      }
    },
    async getTaskList() { // 获取任务列表
      this.$refs.loading.show = true;
      const { code, data } = await getTaskApi(this.id);
      if (code === 0) this.taskInfo = data;
      this.getisContainCommunity();
      this.getAddress();
    },
    goMockExam(type) { // 去入学测试
      const {
        examId,
      } = this.taskInfo;
      const { origin } = window.location;
      if (type === 1) { // 去做题
        window.location.href = `${origin}/mockExam/paper?hiddenNavigationBar=1&examId=${examId}`;
      } else { // 去解析
        window.location.href = `${origin}/mockExam/answerReport?examId=${examId}`;
      }
    },
    // 是否有社群
    async getisContainCommunity() {
      const res = await reqCourseDetail({ id: this.id });
      if (res?.code === 0) {
        this.listInfo = res?.data;
        this.isContainCommunity = res?.data.isContainCommunity;
      }
    },
    async GroupBtn() {
      const { productId, skuId } = this.listInfo;
      this.showPop = true;
      const request = await reqCourseCommunitySku(productId, skuId);
      this.communityInfo = request.data;
      if (request.code === 0 && request.data) {
        const { data } = request;
        this.communityType = `${data.platform}-${data.accountType}`;
      } else {
        this.communityType = 'wxAccount';
      }
    },

  },
  mounted() {
    this.getTaskList();
  },
};
</script>
<style lang="scss" scoped>
.entranceTask {
  padding: 150px 36px 0;
  .title {
    width: 100%;
  }
  .taskList {
    position: relative;
    top: -100px;
    width: 100%;
    padding: 36px;
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 -4px 18px 0 rgba(93, 49, 27, 0.05);
    li {
      display: flex;
      align-items: center;
      width: 100%;
      height: 129px;
      font-size: 25px;
      border-bottom: 2px solid #f8f8f8;
      img {
        width: 36px;
        height: 36px;
        margin-right: 14px;
      }
      a {
        width: 116px;
        height: 42px;
        margin-left: auto;
        color: #fff;
        font-size: 22px;
        line-height: 42px;
        text-align: center;
        background: #ff7f41;
        border-radius: 22px;
      }
    }
  }
  .fixBottom {
    position: fixed;
    bottom: 80px;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 678px;
    height: 80px;
    color: #fff;
    font-size: 29px;
    background: #ff7f41;
    border-radius: 45px;
    transform: translateX(-50%);
  }
  .isDone {
    background: #dcdcdc;
  }
  .aKeyGroup {
    width: 185px;
    height: 185px;
    position: fixed;
    right: 0;
    bottom: 18%;
    img {
      width: 185px;
      height: 185px;
    }
  }
  ::v-deep .van-popup {
    border-radius: 14px 14px 0 0;
  }

  .close-btn {
    position: absolute;
    top: 67px;
    right: 29px;
    z-index: 999;
    display: flex;
    color: #a8a8a8;

    i {
      font-size: 40px;
    }
  }
}
</style>
